(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"), require("chartjs"), require("experiment-mathjs"));
	else if(typeof define === 'function' && define.amd)
		define("experimentBoxes", ["jQuery", "chartjs", "experiment-mathjs"], factory);
	else if(typeof exports === 'object')
		exports["experimentBoxes"] = factory(require("jQuery"), require("chartjs"), require("experiment-mathjs"));
	else
		root["experimentBoxes"] = factory(root["jQuery"], root["Chart"], root["math"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition